export const actions = {
    getAllStocks: "GETALLSTOCKS",
    login: "LOGIN",
    getUser: "GETUSER",
    xlsxBotSendMail: "XLSXBOTSENDMAIL",
    readyToShipBotSendMail: "READYTOSHIPBOTSENDMAIL",
    readyToShipBotStatus: "READYTOSHIPBOTSTATUS",
    changeStatusReadyToShip: "CHANGESTATUSREADYTOSHIP",
}